import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Badge,
  Alert,
  Row,
  Col
} from "reactstrap";

const ModalDocumentacionMetricas = ({ isOpen, toggle }) => {
  const [tabActiva, setTabActiva] = useState("kpis");

  const FormulaBox = ({ formula, descripcion }) => (
    <div className="bg-light p-3 rounded border mb-3">
      <code className="text-primary fs-14">{formula}</code>
      {descripcion && <p className="text-muted mb-0 mt-2 small">{descripcion}</p>}
    </div>
  );

  const EjemploBox = ({ titulo, contenido }) => (
    <Alert color="info" className="border-info">
      <h6 className="alert-heading fs-13 mb-2">
        <i className="ri-lightbulb-line me-1"></i> {titulo}
      </h6>
      <div className="small">{contenido}</div>
    </Alert>
  );

  const GraficoIQR = () => (
    <div className="text-center my-3">
      <svg width="100%" height="120" viewBox="0 0 600 120">
        <line x1="50" y1="60" x2="550" y2="60" stroke="#6c757d" strokeWidth="2" />
        <line x1="100" y1="40" x2="100" y2="80" stroke="#6c757d" strokeWidth="2" />
        <line x1="500" y1="40" x2="500" y2="80" stroke="#6c757d" strokeWidth="2" />
        <rect x="200" y="35" width="200" height="50" fill="#0ab39c" fillOpacity="0.3" stroke="#0ab39c" strokeWidth="2" />
        <line x1="200" y1="35" x2="200" y2="85" stroke="#0ab39c" strokeWidth="3" />
        <line x1="300" y1="35" x2="300" y2="85" stroke="#f06548" strokeWidth="3" />
        <line x1="400" y1="35" x2="400" y2="85" stroke="#0ab39c" strokeWidth="3" />
        <circle cx="70" cy="60" r="5" fill="#f06548" />
        <circle cx="530" cy="60" r="5" fill="#f06548" />
        <text x="70" y="100" textAnchor="middle" fontSize="11" fill="#f06548">Outlier Bajo</text>
        <text x="100" y="100" textAnchor="middle" fontSize="11" fill="#6c757d">Mín</text>
        <text x="200" y="100" textAnchor="middle" fontSize="11" fill="#0ab39c">Q1</text>
        <text x="300" y="100" textAnchor="middle" fontSize="11" fill="#f06548">Q2</text>
        <text x="400" y="100" textAnchor="middle" fontSize="11" fill="#0ab39c">Q3</text>
        <text x="500" y="100" textAnchor="middle" fontSize="11" fill="#6c757d">Máx</text>
        <text x="530" y="100" textAnchor="middle" fontSize="11" fill="#f06548">Outlier Alto</text>
      </svg>
    </div>
  );

  const GraficoDesviacion = () => (
    <div className="text-center my-3">
      <svg width="100%" height="140" viewBox="0 0 600 140">
        <path d="M 50 120 Q 150 20, 300 10 T 550 120" fill="none" stroke="#405189" strokeWidth="2" />
        <path d="M 50 120 Q 150 20, 300 10 T 550 120 L 550 120 L 50 120" fill="#405189" fillOpacity="0.1" />
        <line x1="300" y1="10" x2="300" y2="130" stroke="#f06548" strokeWidth="2" strokeDasharray="5,5" />
        <line x1="200" y1="30" x2="200" y2="130" stroke="#0ab39c" strokeWidth="2" strokeDasharray="5,5" />
        <line x1="400" y1="30" x2="400" y2="130" stroke="#0ab39c" strokeWidth="2" strokeDasharray="5,5" />
        <line x1="100" y1="80" x2="100" y2="130" stroke="#f7b84b" strokeWidth="2" strokeDasharray="5,5" />
        <line x1="500" y1="80" x2="500" y2="130" stroke="#f7b84b" strokeWidth="2" strokeDasharray="5,5" />
        <rect x="200" y="120" width="200" height="5" fill="#0ab39c" fillOpacity="0.5" />
        <rect x="100" y="120" width="100" height="5" fill="#f7b84b" fillOpacity="0.5" />
        <rect x="400" y="120" width="100" height="5" fill="#f7b84b" fillOpacity="0.5" />
        <text x="100" y="140" textAnchor="middle" fontSize="10" fill="#f06548">μ - 2σ</text>
        <text x="200" y="140" textAnchor="middle" fontSize="10" fill="#0ab39c">μ - σ</text>
        <text x="300" y="140" textAnchor="middle" fontSize="11" fill="#f06548" fontWeight="bold">μ</text>
        <text x="400" y="140" textAnchor="middle" fontSize="10" fill="#0ab39c">μ + σ</text>
        <text x="500" y="140" textAnchor="middle" fontSize="10" fill="#f06548">μ + 2σ</text>
        <text x="300" y="100" textAnchor="middle" fontSize="10" fill="#0ab39c">68%</text>
      </svg>
    </div>
  );

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" scrollable fullscreen="lg">
      <ModalHeader toggle={toggle} className="bg-primary text-white">
        <div className="d-flex align-items-center">
          <i className="ri-book-open-line fs-20 me-2"></i>
          <div>
            <h5 className="modal-title mb-0 text-white">Documentación de Métricas del Dashboard</h5>
            <small className="text-white" style={{opacity: 0.9}}>Guía completa de cálculos, fórmulas y metodologías</small>
          </div>
        </div>
      </ModalHeader>
      
      <ModalBody className="bg-light">
        <Nav tabs className="nav-tabs-custom nav-primary mb-4">
          <NavItem>
            <NavLink
              className={tabActiva === "kpis" ? "active" : ""}
              onClick={() => setTabActiva("kpis")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-dashboard-line me-1"></i>
              KPIs Principales
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tabActiva === "outliers" ? "active" : ""}
              onClick={() => setTabActiva("outliers")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-alert-line me-1"></i>
              Outliers
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tabActiva === "estadisticos" ? "active" : ""}
              onClick={() => setTabActiva("estadisticos")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-function-line me-1"></i>
              Métodos Estadísticos
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tabActiva === "percentiles" ? "active" : ""}
              onClick={() => setTabActiva("percentiles")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-bar-chart-box-line me-1"></i>
              Percentiles
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tabActiva === "coeficiente" ? "active" : ""}
              onClick={() => setTabActiva("coeficiente")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-percent-line me-1"></i>
              Coeficiente de Variación
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tabActiva === "alertas" ? "active" : ""}
              onClick={() => setTabActiva("alertas")}
              style={{ cursor: "pointer" }}
            >
              <i className="ri-alarm-warning-line me-1"></i>
              Sistema de Alertas
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={tabActiva}>
          {/* TAB: KPIs */}
          <TabPane tabId="kpis">
            <Row>
              <Col lg={6}>
                <Card className="border">
                  <CardBody>
                    <h5 className="card-title text-primary mb-3">
                      <i className="ri-file-list-3-line me-2"></i>
                      Total de Facturas
                    </h5>
                    <FormulaBox 
                      formula="Total = COUNT(solicitudes con facturación en período)"
                    />
                    <EjemploBox
                      titulo="Ejemplo"
                      contenido={<>Total: 121 facturas (20 agudas + 101 crónicas)</>}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col lg={6}>
                <Card className="border">
                  <CardBody>
                    <h5 className="card-title text-success mb-3">
                      <i className="ri-money-dollar-circle-line me-2"></i>
                      Total Facturado USD
                    </h5>
                    <FormulaBox 
                      formula="Total USD = SUM(facturacion[0].montoDolar)"
                    />
                    <FormulaBox 
                      formula="Promedio = Total USD / Total Facturas"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>

          {/* TAB: Outliers */}
          <TabPane tabId="outliers">
            <Row>
              <Col lg={6}>
                <Card className="border border-danger">
                  <CardBody>
                    <h5 className="card-title text-danger mb-3">
                      <i className="ri-alert-fill me-2"></i>
                      Método IQR
                    </h5>
                    <FormulaBox formula="IQR = Q3 - Q1" />
                    <FormulaBox formula="Límite Inferior = Q1 - 1.5 × IQR" />
                    <FormulaBox formula="Límite Superior = Q3 + 1.5 × IQR" />
                    <GraficoIQR />
                    <EjemploBox
                      titulo="Ejemplo"
                      contenido={<>Q1: $15.50, Q3: $35.00, IQR: $19.50<br/>Límites: -$13.75 a $64.25</>}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col lg={6}>
                <Card className="border border-warning">
                  <CardBody>
                    <h5 className="card-title text-warning mb-3">
                      <i className="ri-line-chart-line me-2"></i>
                      Desviación Estándar
                    </h5>
                    <FormulaBox formula="σ = √(Σ(xi - μ)² / n)" />
                    <FormulaBox formula="Límite Inferior = μ - 2σ" />
                    <FormulaBox formula="Límite Superior = μ + 2σ" />
                    <GraficoDesviacion />
                    <EjemploBox
                      titulo="Ejemplo"
                      contenido={<>Media: $28.50, σ: $12.30<br/>Límites: $3.90 a $53.10</>}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>

          {/* TAB: Métodos Estadísticos */}
          <TabPane tabId="estadisticos">
            <Card className="border">
              <CardBody>
                <h5 className="card-title text-info mb-3">Comparación de Métodos</h5>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>Característica</th>
                        <th>IQR</th>
                        <th>Desviación Estándar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Robustez</td>
                        <td><Badge color="success">Alta</Badge></td>
                        <td><Badge color="warning">Media</Badge></td>
                      </tr>
                      <tr>
                        <td>Sensibilidad</td>
                        <td>Conservador</td>
                        <td>Agresivo</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </TabPane>

          {/* TAB: Percentiles */}
          <TabPane tabId="percentiles">
            <Row>
              <Col lg={12}>
                <Card className="border border-info">
                  <CardBody>
                    <h5 className="card-title text-info mb-3">
                      <i className="ri-bar-chart-box-line me-2"></i>
                      Percentiles - Distribución de Valores
                    </h5>
                    <p className="text-muted">Los percentiles dividen los datos ordenados en 100 partes iguales, mostrando la distribución de valores.</p>
                    
                    <Row className="mt-4">
                      <Col md={6}>
                        <h6 className="text-primary mb-3">Fórmulas</h6>
                        <FormulaBox 
                          formula="Posición = (n - 1) × (p / 100)"
                          descripcion="n = cantidad de valores, p = percentil deseado"
                        />
                        <FormulaBox 
                          formula="P50 = Mediana (valor central)"
                          descripcion="Más robusto que la media ante valores extremos"
                        />
                      </Col>
                      <Col md={6}>
                        <h6 className="text-primary mb-3">Interpretación</h6>
                        <ul className="list-unstyled">
                          <li className="mb-2"><Badge color="info">P25</Badge> 25% de valores son menores</li>
                          <li className="mb-2"><Badge color="primary">P50</Badge> 50% de valores son menores (mediana)</li>
                          <li className="mb-2"><Badge color="info">P75</Badge> 75% de valores son menores</li>
                          <li className="mb-2"><Badge color="warning">P90</Badge> 90% de valores son menores</li>
                          <li className="mb-2"><Badge color="warning">P95</Badge> 95% de valores son menores</li>
                          <li className="mb-2"><Badge color="danger">P99</Badge> 99% de valores son menores (valores extremos)</li>
                        </ul>
                      </Col>
                    </Row>

                    <EjemploBox
                      titulo="Ejemplo Real - Facturas Agudas"
                      contenido={
                        <>
                          <strong>Datos:</strong> 368 facturas<br/>
                          <strong>P25:</strong> $20.29 → 25% de facturas ≤ $20.29<br/>
                          <strong>P50:</strong> $35.71 → 50% de facturas ≤ $35.71 (mediana)<br/>
                          <strong>P75:</strong> $63.93 → 75% de facturas ≤ $63.93<br/>
                          <strong>P90:</strong> $106.18 → 90% de facturas ≤ $106.18<br/>
                          <strong>P95:</strong> $134.18 → 95% de facturas ≤ $134.18<br/>
                          <strong>P99:</strong> $203.81 → 1% superior llega hasta $203.81
                        </>
                      }
                    />

                    <Alert color="success" className="border-success mt-3">
                      <h6 className="alert-heading fs-13 mb-2">
                        <i className="ri-checkbox-circle-line me-1"></i> Ventajas de los Percentiles
                      </h6>
                      <ul className="mb-0 small">
                        <li>Más robustos que la media ante outliers</li>
                        <li>Muestran la distribución completa de datos</li>
                        <li>Útiles para identificar valores típicos y extremos</li>
                        <li>No asumen distribución normal</li>
                      </ul>
                    </Alert>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>

          {/* TAB: Coeficiente de Variación */}
          <TabPane tabId="coeficiente">
            <Row>
              <Col lg={12}>
                <Card className="border border-warning">
                  <CardBody>
                    <h5 className="card-title text-warning mb-3">
                      <i className="ri-percent-line me-2"></i>
                      Coeficiente de Variación (CV)
                    </h5>
                    <p className="text-muted">Medida de dispersión relativa que permite comparar la variabilidad entre diferentes conjuntos de datos.</p>
                    
                    <Row className="mt-4">
                      <Col md={6}>
                        <h6 className="text-primary mb-3">Fórmula</h6>
                        <FormulaBox 
                          formula="CV = (σ / μ) × 100"
                          descripcion="σ = desviación estándar, μ = media"
                        />
                        <FormulaBox 
                          formula="CV% = Variabilidad Relativa"
                          descripcion="Expresa la desviación como porcentaje de la media"
                        />
                      </Col>
                      <Col md={6}>
                        <h6 className="text-primary mb-3">Interpretación</h6>
                        <div className="mb-3">
                          <Badge color="success" className="me-2">CV {'<'} 50%</Badge>
                          <span className="text-muted">Baja variabilidad - Datos consistentes</span>
                        </div>
                        <div className="mb-3">
                          <Badge color="warning" className="me-2">CV 50-100%</Badge>
                          <span className="text-muted">Variabilidad moderada</span>
                        </div>
                        <div className="mb-3">
                          <Badge color="danger" className="me-2">CV {'>'} 100%</Badge>
                          <span className="text-muted">Alta variabilidad - Datos dispersos</span>
                        </div>
                      </Col>
                    </Row>

                    <EjemploBox
                      titulo="Ejemplo Real - Facturas Agudas"
                      contenido={
                        <>
                          <strong>Media (μ):</strong> $49.69<br/>
                          <strong>Desviación (σ):</strong> $44.30<br/>
                          <strong>CV:</strong> (44.30 / 49.69) × 100 = <strong>89.17%</strong><br/>
                          <strong>Interpretación:</strong> <Badge color="warning">Variabilidad Moderada</Badge> - Los montos tienen dispersión moderada alrededor de la media
                        </>
                      }
                    />

                    <Alert color="info" className="border-info mt-3">
                      <h6 className="alert-heading fs-13 mb-2">
                        <i className="ri-information-line me-1"></i> ¿Cuándo usar CV?
                      </h6>
                      <ul className="mb-0 small">
                        <li>Comparar variabilidad entre datasets con diferentes unidades</li>
                        <li>Evaluar consistencia de precios o costos</li>
                        <li>Identificar procesos que necesitan estandarización</li>
                        <li>Detectar alta dispersión que dificulta proyecciones</li>
                      </ul>
                    </Alert>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>

          {/* TAB: Sistema de Alertas */}
          <TabPane tabId="alertas">
            <Row>
              <Col lg={12}>
                <Card className="border border-primary">
                  <CardBody>
                    <h5 className="card-title text-primary mb-3">
                      <i className="ri-alarm-warning-line me-2"></i>
                      Sistema de Alertas Automáticas
                    </h5>
                    <p className="text-muted">Alertas visuales con colores que identifican automáticamente el estado de cada métrica.</p>
                    
                    <Row className="mt-4">
                      <Col md={6}>
                        <Card className="bg-success-subtle border-success">
                          <CardBody>
                            <h6 className="text-success mb-3">
                              <i className="ri-checkbox-circle-fill me-2"></i>
                              Verde - Excelente/Normal
                            </h6>
                            <ul className="list-unstyled mb-0 small">
                              <li><strong>Calificación:</strong> ≥ 4.5</li>
                              <li><strong>Delivery:</strong> ≥ 70%</li>
                              <li><strong>Pareto:</strong> ≤ 20%</li>
                              <li><strong>Outliers:</strong> {'<'} 5%</li>
                              <li><strong>CV:</strong> {'<'} 50%</li>
                            </ul>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md={6}>
                        <Card className="bg-warning-subtle border-warning">
                          <CardBody>
                            <h6 className="text-warning mb-3">
                              <i className="ri-error-warning-fill me-2"></i>
                              Amarillo - Aceptable/Advertencia
                            </h6>
                            <ul className="list-unstyled mb-0 small">
                              <li><strong>Calificación:</strong> 4.0 - 4.5</li>
                              <li><strong>Delivery:</strong> 50% - 70%</li>
                              <li><strong>Pareto:</strong> 20% - 30%</li>
                              <li><strong>Outliers:</strong> 5% - 10%</li>
                              <li><strong>CV:</strong> 50% - 100%</li>
                            </ul>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col md={6}>
                        <Card className="bg-danger-subtle border-danger">
                          <CardBody>
                            <h6 className="text-danger mb-3">
                              <i className="ri-close-circle-fill me-2"></i>
                              Rojo - Crítico
                            </h6>
                            <ul className="list-unstyled mb-0 small">
                              <li><strong>Calificación:</strong> {'<'} 4.0</li>
                              <li><strong>Delivery:</strong> {'<'} 50%</li>
                              <li><strong>Pareto:</strong> {'>'} 30%</li>
                              <li><strong>Outliers:</strong> {'>'} 10%</li>
                              <li><strong>CV:</strong> {'>'} 100%</li>
                            </ul>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md={6}>
                        <EjemploBox
                          titulo="Ejemplo Real (2025-10-18)"
                          contenido={
                            <>
                              <div className="mb-2">
                                <Badge color="danger" className="me-2">🔴</Badge>
                                <strong>Delivery: 37.19%</strong> → Crítico<br/>
                                <small className="text-muted">Acción: Aumentar cobertura urgente</small>
                              </div>
                              <div className="mb-2">
                                <Badge color="danger" className="me-2">🔴</Badge>
                                <strong>Pareto: 49.92%</strong> → Crítico<br/>
                                <small className="text-muted">Acción: Diversificar servicios</small>
                              </div>
                              <div className="mb-2">
                                <Badge color="success" className="me-2">🟢</Badge>
                                <strong>Calificación: 4.69</strong> → Excelente<br/>
                                <small className="text-muted">Acción: Mantener calidad</small>
                              </div>
                              <div>
                                <Badge color="warning" className="me-2">🟡</Badge>
                                <strong>CV Agudas: 89.17%</strong> → Advertencia<br/>
                                <small className="text-muted">Acción: Revisar pricing</small>
                              </div>
                            </>
                          }
                        />
                      </Col>
                    </Row>

                    <Alert color="primary" className="border-primary mt-3">
                      <h6 className="alert-heading fs-13 mb-2">
                        <i className="ri-lightbulb-line me-1"></i> Beneficios del Sistema de Alertas
                      </h6>
                      <ul className="mb-0 small">
                        <li><strong>Detección Proactiva:</strong> Identifica problemas antes de que escalen</li>
                        <li><strong>Priorización:</strong> Enfoca atención en métricas críticas (rojas)</li>
                        <li><strong>Accionable:</strong> Cada alerta sugiere acciones específicas</li>
                        <li><strong>Visual:</strong> Colores intuitivos para identificación rápida</li>
                        <li><strong>Automático:</strong> No requiere análisis manual constante</li>
                      </ul>
                    </Alert>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </ModalBody>
      
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          <i className="ri-close-line me-1"></i>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalDocumentacionMetricas;
